exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper .widget-icon{width:20px;height:20px;margin:0 7px}", ""]);

// exports
